<template>
  <div>
    <mrc_ess_table v-if="$route.name == 'version'" :headers="headers" pageName="addVersion" :paginationOptions="options"
      @turnPage="getlist" :isLoading="loading" :slotKey="['version_name']" :hideAddBtn="!hasBtn('add-version-management')"
      :items="desserts">
      <template v-slot:item.version_name="{ item }">
        <span>{{ INT(item.version_name) }}</span>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <!-- v-btnAuth="['view-staff-version',
                                'edit-staff-version',
                                'delete-staff-version']" -->
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view-version-management',
              'edit-version-management',
              'delete-version-management',
            ]">mdi-dots-vertical
            </v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getBusinessList } from "@/service/api/prompt.js";
import {
  getVersionList,
  addVersion,
  updateVersion,
  deleteVersion,
  detailVersion,
} from "@/service/api/version.js";
import Cookie from "js-cookie";
export default {
  components: {},
  props: {},
  data() {
    return {
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    };
  },
  computed: {
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-version-management"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-version-management"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-version-management"),
          type: "del",
        },
        // { name: this.$t('label_View'), show: true, type: 'view' },
        // { name: this.$t('label_Edit'), show: true, type: 'edit' },
        // { name: this.$t('label_delete'), show: true, type: 'del' },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("label_system_version_name"),
          align: "start",
          value: "version_name",
          sortable: false,
        },
        {
          text: this.$t("label_system_version_code"),
          value: "version_code",
          sortable: false,
        },
        {
          text: this.$t("label_clientType"),
          value: "version_type",
          sortable: false,
        },
        // { text: this.$t('label_The_execution_status'), value: 'result_status', sortable: false, },
        { text: "", value: "actions", sortable: false, align: "end" },
      ];
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  watch: {
    $route(v) {
      if (v.name == "version") {
        this.getlist();
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getlist();
    this.loading = false;
  },
  beforeDestroy() {
    this.$ls.remove("staffList");
  },
  methods: {
    async getlist(obj) {
      this.loading = true;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = obj;
      }
      const res = await getVersionList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
      }
      this.loading = false;
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit("set_subPage_name", item.version_name || "");
      this.$store.commit("set_uuid", item.uuid); //
      this.$router.push({
        name: "detailVersion",
      });
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.$store.commit("set_subPage_name", obj.version_name || "");
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid); //
          this.$router.push({
            name: "detailVersion",
          });
          break;
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteVersion({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (this.desserts.length == 1) this.options.cpage--;
                this.getlist();
              }
            });
          });
          break;
      }
    },
    success() { },
    cancel() { },
  },
};
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
